// extracted by mini-css-extract-plugin
module.exports = {"interviewThumb":"company-detail-interviews_component_interviewThumb__XTQ_s","interviewsBlock":"company-detail-interviews_component_interviewsBlock__Vki_B"};